import { ThemeOptions } from "@mui/material/styles/createTheme";

const OUTLINE = "1px solid #005388";

export const escsMuiThemeOptions: ThemeOptions = {
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          height: "100%",
          margin: 0,
          fontFamily: `-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,
  "Noto Sans",sans-serif,"Apple Color Emoji",
  "Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";
-webkit-font-smoothing: antialiased;
-moz-osx-font-smoothing: grayscale;`
        },
        body: {
          height: "100%",
          margin: 0,
          fontFamily: `-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,
  "Noto Sans",sans-serif,"Apple Color Emoji",
  "Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";
-webkit-font-smoothing: antialiased;
-moz-osx-font-smoothing: grayscale;`
        },
        "#root": {
          display: "flex",
          flexDirection: "column",
          minHeight: "100%"
        }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        notchedOutline: {
          borderColor: "rgba(0, 0, 0, 0.5)"
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        outlined: {
          border: "1px solid rgba(0, 0, 0, 0.5)"
        }
      }
    },
    MuiInput: {
      styleOverrides: {
        root: {
          "&::before": {
            borderBottom: "1px solid rgba(0, 0, 0, 0.5)"
          }
        }
      }
    },
    MuiChip: {
      styleOverrides: {
        outlined: {
          border: "1px solid rgba(0, 0, 0, 0.5)"
        }
      }
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          // Placeholder colour override — AP027 / DIG602.
          // The browser default placeholder colour (rgba(0,0,0,0.42)) only
          // achieves ~2.68:1 against white, failing the WCAG 4.5:1 threshold.
          // rgba(0,0,0,0.6) renders as ~#666666, giving ~5.74:1 against white.
          // opacity:1 prevents Firefox/Safari from applying their own reduction.
          "&::placeholder": {
            color: "rgba(0, 0, 0, 0.6)",
            opacity: 1
          }
        }
      }
    },
    MuiButtonBase: {
      styleOverrides: {
        root: {
          // Keyboard focus indicator — AP114 / DIG605.
          // Covers buttons, icon buttons, menu items, tabs, list items,
          // checkboxes, radios, switches and chips (anything built on
          // ButtonBase). Mui-focusVisible is only applied for keyboard
          // focus, so mouse clicks remain visually clean.
          "&.Mui-focusVisible": {
            outline: OUTLINE,
            outlineOffset: "2px"
          }
        }
      }
    },
    MuiLink: {
      styleOverrides: {
        root: {
          // Keyboard focus indicator — AP114 / DIG605.
          "&:focus-visible": {
            outline: OUTLINE,
            outlineOffset: "2px",
            borderRadius: "2px"
          }
        }
      }
    }
  },
  palette: {
    primary: {
      main: "#005388"
    },
    secondary: {
      main: "#fa9b0e"
    },
    divider: "rgba(0, 0, 0, 0.5)"
  }
};
